import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ImageUploadPublic } from '../../../../globalTypes/image.types';

@Component({
  selector: 'msh-select-image',
  imports: [],
  template: `
    @if(images.length > 0){
      <div class="flex gap-3 flex-wrap">
        @for (image of images; track image.image.id; let imageIndex = $index) {
          <img
            (click)="onSelect(image.image.id)"
            [src]="image.image.url"
            [class]="'max-h-14 bg-navy-50 max-w-14 object-contain border-4 rounded cursor-pointer ' + ( selectedId === image.image.id ? ' border-orange-400 ' : '  hover:border-orange-100 border-transparent')"
          />
        }
      </div>
    } @else {
      <div class="null">No images to select from</div>
    }
  `,
  styles: ``
})
export class SelectImageComponent implements OnChanges {
  @Input() images: {sortOrder: number, image:ImageUploadPublic} [] = [];
  @Input() selectedId?: string;
  @Output() selectedIdChange: EventEmitter<string> = new EventEmitter<string>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['images']) {
      this.images.sort((a, b) => a.sortOrder - b.sortOrder);
    }
  }

  onSelect(selectedId: string){
    this.selectedIdChange.emit(selectedId);
  }
}
